import { createWeightColumnDefinition } from './weight-column-helper';
import { messages } from '../messages';

export const createTareWeightColumnDefinition = createWeightColumnDefinition({
  accessor: 'tareWeight',
  headerMessage: messages.tareWeightColumnHeader,
});
